<template>
    <div v-if="IsMobile" style="position:sticky; bottom: 0px; margin-top: auto;">
        <var-floating-panel v-model:anchor="aiObj.anchor" :anchors="aiObj.anchors">
            <var-skeleton title avatar card :loading="false">
                <HomeComponent></HomeComponent>
                <CloseFabButtonComponent @OnClose="onCloseFabButton"></CloseFabButtonComponent>
            </var-skeleton>
        </var-floating-panel>

        <var-bottom-navigation
            :fab-props="{ type: 'default', elevation: 24, style: 'width:50px; height:50px;border-radius: 50%;', color: 'transparent', 'iconContainer': true }"
            v-if="isFind" v-model:active="activeMenuIndex" @change="OnChange">
            <var-bottom-navigation-item v-for="v in menuList" :label="v.title" namespace="icon" :icon="v.iconName" />
            <template #fab>
                <var-image @click="OpenAi()" width="50px" height="50px"
                    :src="$R(systemConfigStore.getConfig?.AiIconBtn)">
                </var-image>
            </template>
        </var-bottom-navigation>
    </div>
    <div v-else>
        <div class="pc-bottom-body" v-if="aiObj.show">
            <HomeComponent></HomeComponent>
        </div>
        <div v-if="!aiObj.show" class="ai-icon-box">
            <var-image fit="cover" @click="OpenAi()" width="100%" height="100%"
                :src="$R(systemConfigStore.getConfig?.AiIconBtn)">
            </var-image>
        </div>
        <CloseFabButtonComponent @OnClose="CloseAi" v-else></CloseFabButtonComponent>
    </div>
</template>

<script setup lang="ts">
import router from '@/router';
import { useMenuStore } from '@/store/menu';
import { computed, inject, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import HomeComponent from "@/components/AiComponents/HomeComponent.vue";
import CloseFabButtonComponent from '../GlobalComponents/CloseFabButtonComponent.vue';
import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useLocale } from '@/hooks/useLocale';
const menuIndex = useMenuStore();
const IsMobile = inject<boolean>("IsMobile");
const systemConfigStore = useSystemConfigStore();

const maxHeight = computed(() => {
    return globalThis.innerHeight - 50;
});
const local = useLocale();
const aiObj = ref<{
    show: boolean;
    anchor: number;
    anchors: number[],
}>({
    show: false,
    anchor: maxHeight.value, //默认最高
    anchors: [0, maxHeight.value],
})

const activeMenuIndex = computed({
    get() {
        return menuIndex.getMenuIndex ?? 0;  // 从 store 获取值
    },
    set(value) {
        menuIndex.setMenuIndex(value);  // 通过 action 更新 store
    }
});

const route = useRoute();
const isFind = ref(false);

const menuList = computed(() => [
    {
        title: local.t('components.BottomComponent.menus.hangqing'),
        iconName: 'hangqing-',
        path: '/'
    },
    {
        title: local.t('components.BottomComponent.menus.heyue'),
        iconName: 'heyue',
        path: '/contract'
    },
    // {
    //     title: local.t('components.BottomComponent.menus.qiquan'),
    //     iconName: 'gupiaoqiquan',
    //     path: '/options'
    // },
    {
        title: local.t('components.BottomComponent.menus.xianhuo'),
        iconName: 'jiaoyi',
        path: '/transaction'
    },
    {
        title: local.t('components.BottomComponent.menus.wode'),
        iconName: 'wode',
        path: '/me'
    }
]);

watch(() => route.path, (n, o) => {
    let index = 0;
    for (let i = 0; i < menuList.value.length; i++) {
        if (menuList.value[i].path === n) {
            index = i;
            isFind.value = true;
            activeMenuIndex.value = index;
            return;
        }
    }
    isFind.value = false;
}, {
    immediate: true
});

function OnChange(index: number | string) {
    const indexNum = typeof index === 'number' ? index : +index;
    //跳转页面
    router.push(menuList.value[indexNum].path);
}

/**
 * 打开AI
 */
function OpenAi() {
    aiObj.value.show = true;
    aiObj.value.anchor = window.innerHeight * 0.6;
}

function CloseAi() {
    aiObj.value.show = false;
}

function onCloseFabButton() {

    // aiObj.value.show = false;
    aiObj.value.anchor = 0;
}

</script>

<style lang="scss" scoped>
.card {
    padding: 10px;
    box-sizing: border-box;
    border-radius: 10px !important;
    background-color: var(--card-background);
    color: var(--card-content-color);
    width: 100%;
    margin: 10px;
    overflow: hidden;

    .card-content {
        display: flex;
        width: 100%;
        align-items: center;
        overflow: hidden;

        .icon {
            width: 80px;
            height: 80px;
            min-width: 80px;
        }

        .right {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            padding: 20px;
            padding-bottom: 10px;
            padding-right: 10px;
            box-sizing: 10px;
            overflow: hidden;

            .title {
                font-size: 20px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .line-box {
                width: 1px;
                height: 100%;
                display: flex;
                align-items: center;

                .line {
                    width: 1px;
                    height: 60%;
                    background: rgba(255, 255, 255, 0.1);
                }
            }

            .min-amount-title {
                font-size: 14px;
                color: #828282;
                font-weight: bold;
            }

            .min-amount {
                color: #632EFF !important;
            }
        }
    }
}

.create-ai-box-title {
    margin-top: 10px !important;
    font-size: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.create-ai-box {
    display: flex;
    flex-direction: column;
    // padding: 20px;
    box-sizing: border-box;
    justify-content: space-between;
    font-weight: bold;
    width: 100%;

    .create-ai-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 10px;
        box-sizing: border-box;

        .title {
            font-size: 12px;
            color: var(--card-content-color);
        }

        .price {
            color: var(--card-content-color);
            font-size: 12px;
        }
    }

    .line {
        width: 100%;
        height: 1px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .select {
        padding: 10px;
    }

    .input-count-box {
        display: flex;
        width: 100%;
        align-items: center;
        margin-top: 20px;

        .tz-btn {
            margin-left: 10px;
            flex-grow: 1;
        }

        .close-btn {
            width: 100%;
        }
    }
}

.pc-bottom-body {
    display: flex;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    position: fixed;
    z-index: 10;
    color: var(--color-text);
    color-scheme: var(--color-scheme);
    background-color: var(--color-body);
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }
}

.ai-icon-box {
    width: 60px;
    height: 60px;
    min-width: 50px;
    min-height: 50px;
    overflow: hidden;
    position: fixed;
    right: 20px;
    top: 45%;
    z-index: 10;
    border-radius: 50%;
    box-sizing: border-box;
    border: 3px solid white !important;
}
</style>
